const GetEOPDRegisterStatusName = (id) =>{

    switch (id) {
        case 0: { return "Accepted" }
        case 1: { return "Rejected" }
        case 2: { return "Pending" }

}
}
const GetEOPDRegisterstatus = {
    GetEOPDRegisterstatus: [
        { Id: 0, Name: "Accepted" },
        { Id: 1, Name: "Rejected" },
        { Id: 2, Name: "Pending" },

    ]
}

const EOPDRegisteredStatusBg = (id) => {
    switch (id) {
        case 0: { return "bg-green-400" }
        case 1: { return "bg-red-400" }
        case 2: { return "bg-orange-400" }
    }
}

const EOPDRegisteredStatusText = (id) => {
    switch (id) {
        case 0: { return "text-green-600" }
        case 1: { return "text-red-600" }
        case 2: { return "text-orange-600" }
    }
}

export {GetEOPDRegisterStatusName, GetEOPDRegisterstatus,EOPDRegisteredStatusBg, EOPDRegisteredStatusText}

